import { getLogger } from '@jitsi/logger';
import { getCurrentConference } from '../../../react/features/base/conference/functions';
import { hideDialog, openDialog } from '../../../react/features/base/dialog/actions';
import { JitsiConferenceEvents } from '../../../react/features/base/lib-jitsi-meet';
import {
    getParticipantByIdOrUndefined,
    getParticipantDisplayName, getPinnedParticipant
} from '../../../react/features/base/participants/functions';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import {
    showErrorNotification,
    showWarningNotification
} from '../../../react/features/notifications/actions';
import {
    NOTIFICATION_TIMEOUT_TYPE
} from '../../../react/features/notifications/constants';
import { XMPPEvents } from 'lib-jitsi-meet/dist/esm/service/xmpp/XMPPEvents';
import { RequestControlDialog } from '../../components/wildix-remote-control';
import {
    addQueryDialog,
    callQueryDialogByStep,
    controlSharingIsBusy,
    createDataChanel, hideRequestControlDialog,
    notificationStatusService,
    pauseMouseEvents, removeWaitingQueue,
    resumeMouseEvents,
    sendEventServiceNotInstalled,
    sendEventToCloseConnection,
    sendToAllUserStatusSharing,
    setControlledUserID, setDefaultStoreControlSharing,
    setLaunchedUserID,
    setSelfControl,
    setStatusControl, setVirtualScreenSharingID,
    showNotificationFromRemoteUser,
    showNotificationIfNoWiService,
    showNotificationSharingFirefox,
    showNotificationSharingTab,
    stopController,
    toggleAdminState,
    togglePauseResumeControl,
    toggleSelectorControlSharing, userApproved, userRejected,
    wildixServiceDisconnected,
    wildixServiceRestored
} from '../../components/wildix-remote-control/actions';
import ControlSharingDialogList
from '../../components/wildix-remote-control/components/web/ControlSharingDialogList';
import {
    changeHeightSharingForLaunchingUser,
    isDialogOpened,
    isFirefoxLocalSharing, isScreenSharingPlayingByUserID,
    isSharingTab
} from '../../components/wildix-remote-control/functions';

import {
    REQUEST_TYPES,
    STATUSES,
    WEBRTC_TYPES,
    WISERVICE_TYPES,
    WIS_CONTROL_EVENTS
} from './constants';

const logger = getLogger(__filename);

StateListenerRegistry.register(
    state => getCurrentConference(state),
    (conference, { dispatch, getState }, store) => {
        if (!conference) {
            return;
        }
        const myUserID = conference.myUserId();

        conference.room?.addListener(XMPPEvents.JSON_MESSAGE_RECEIVED, (from, objectData = {}) => {
            if (objectData.type === WEBRTC_TYPES.CONTROL_OFFER) {
                APP.wildix.controlSharing.gotMessageFromServer(objectData);

                return;
            }

            if (!objectData.isRequestControl) {
                return;
            }
            const state = getState();

            const {
                statusControl,
                isAutoStart,
                launchedControlID: launchedControlIDFromStore
            } = state['wildix/features/control-sharing'];
            const { isConnected } = state['wildix/features/wiservice'];

            logger.warn(statusControl, objectData, 'statusControl, objectData JSON_MESSAGE_RECEIVED');
            if (statusControl === STATUSES.PENDING) {
                return;
            }
            const {
                launchedControlID,
                controlledUserId,
                isUserGivesSelfControl,
                virtualScreenID,
                type } = objectData;
            const launchedName = getParticipantDisplayName(state, launchedControlID);
            const controlledName = getParticipantDisplayName(state, controlledUserId);

            switch (type) {
            case REQUEST_TYPES.CONTROL: {
                const objectForDialog = {
                    CONTROL_DIALOG_REQUEST: REQUEST_TYPES.CONTROL_DIALOG_REQUEST,
                    controlledUserId,
                    launchedName,
                    isUserGivesSelfControl,
                    launchedControlID,
                    dispatch
                };

                if (isDialogOpened(state) || isAutoStart) {
                    dispatch(addQueryDialog(objectForDialog, launchedControlID));

                    return;
                }

                if (statusControl === STATUSES.OPENED && launchedControlID !== launchedControlIDFromStore) {
                    dispatch(controlSharingIsBusy(launchedControlID, controlledUserId));

                    return;
                }

                if (myUserID === controlledUserId) {

                    if (isFirefoxLocalSharing(state)) {
                        dispatch(showNotificationSharingFirefox(controlledUserId, launchedControlID));

                        return;
                    } else if (isSharingTab(state)) {
                        dispatch(showNotificationSharingTab(controlledUserId, launchedControlID));

                        return;
                    }
                    dispatch(setSelfControl(isUserGivesSelfControl));
                    if (isConnected || isUserGivesSelfControl) {
                        dispatch(openDialog(RequestControlDialog, objectForDialog));
                        dispatch(setStatusControl(STATUSES.REQUESTING));
                    } else {
                        dispatch(sendEventServiceNotInstalled(launchedControlID, isUserGivesSelfControl));
                    }
                }
                break;
            }
            case REQUEST_TYPES.CONTROL_BUSY: {
                dispatch(showNotificationFromRemoteUser(type, controlledUserId));
                break;
            }
            case REQUEST_TYPES.CONTROL_REJECTED_TAB: {
                dispatch(setStatusControl(null));
                dispatch(hideDialog(ControlSharingDialogList));
                dispatch(showWarningNotification({
                    titleKey: 'controlSharing.titleDialogControl',
                    descriptionKey: 'controlSharing.screenSharingTabRemote',
                    descriptionArguments: { name: controlledName }
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                dispatch(setDefaultStoreControlSharing());

                break;
            }
            case REQUEST_TYPES.CONTROL_REJECTED_FIREFOX: {
                dispatch(setStatusControl(null));
                dispatch(hideDialog(ControlSharingDialogList));
                dispatch(showWarningNotification({
                    titleKey: 'controlSharing.titleDialogControl',
                    descriptionKey: 'controlSharing.screenSharingFirefoxRemote',
                    descriptionArguments: { name: launchedName }
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                break;
            }
            case REQUEST_TYPES.CONTROL_CLOSE: {
                if (myUserID === launchedControlID) {
                    dispatch(stopController());
                    dispatch(showNotificationFromRemoteUser(type, controlledUserId));
                }
                break;
            }
            case REQUEST_TYPES.CONTROL_NOT_INSTALLED: {
                dispatch(setStatusControl(null));
                dispatch(hideDialog(ControlSharingDialogList));
                dispatch(showNotificationIfNoWiService(type, controlledUserId, isUserGivesSelfControl));
                break;
            }
            case REQUEST_TYPES.CONTROL_APPROVED: {
                dispatch(hideDialog(ControlSharingDialogList));
                dispatch(setStatusControl(STATUSES.PENDING));
                dispatch(setLaunchedUserID(launchedControlID));
                dispatch(setControlledUserID(controlledUserId));
                dispatch(setVirtualScreenSharingID(virtualScreenID));
                dispatch(toggleAdminState(myUserID === launchedControlID));
                if (isUserGivesSelfControl) {
                    dispatch(showNotificationFromRemoteUser(type, launchedControlID));
                } else {
                    dispatch(createDataChanel());
                    dispatch(showNotificationFromRemoteUser(type, controlledUserId));
                }
                break;
            }
            case REQUEST_TYPES.CONTROL_REJECTED: {
                dispatch(hideDialog(ControlSharingDialogList));
                dispatch(setStatusControl(null));
                dispatch(setControlledUserID(null));
                dispatch(setLaunchedUserID(null));
                dispatch(showNotificationFromRemoteUser(type, controlledUserId));
                break;
            }
            case REQUEST_TYPES.CONTROL_WAS_STOPPED: {
                dispatch(showNotificationFromRemoteUser(type, controlledUserId));
                break;
            }
            case WISERVICE_TYPES.serviceStopped: {
                dispatch(setStatusControl(STATUSES.STOPPED));
                dispatch(pauseMouseEvents());
                dispatch(notificationStatusService(type));
                break;
            }
            case WISERVICE_TYPES.serviceConnected: {
                dispatch(setStatusControl(STATUSES.OPENED));
                dispatch(resumeMouseEvents());
                dispatch(notificationStatusService(type));
                break;
            }
            }
        });

        conference.on(JitsiConferenceEvents.USER_LEFT, userId => {
            const state = getState();
            const {
                active,
                isUserGivesSelfControl,
                launchedControlID,
                controlledUserId,
                arrayQueue,
                statusControl
            } = state['wildix/features/control-sharing'];
            const isNotActiveStatus = !statusControl || statusControl === STATUSES.CLOSED;
            const controlledOrLaunchedId = isUserGivesSelfControl ? launchedControlID : controlledUserId;

            if (!active && isNotActiveStatus) {
                return;
            }

            if (!active && userId === controlledOrLaunchedId) {
                dispatch(setStatusControl(null));
                dispatch(setControlledUserID(null));
                dispatch(setLaunchedUserID(null));

                return;
            }

            if (active && userId === launchedControlID) {
                dispatch(sendToAllUserStatusSharing(STATUSES.CLOSED));

                return;
            }

            if (arrayQueue.size !== 0 && arrayQueue.has(userId)) {
                dispatch(removeWaitingQueue(userId));

                return;
            }

            const { componentProps = {} } = state['features/base/dialog'];
            const { launchedControlID: dialogLaunchedControlID } = componentProps;

            if (userId === dialogLaunchedControlID) {
                dispatch(hideRequestControlDialog());
            }
        });
    }
);


/**
 * Updates the on stage participant video.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/large-video'].participantId,
    /* listener */ (participantId, { dispatch, getState }, previousUserID) => {
        const state = getState();
        const { conference } = state['features/base/conference'];
        const { tileViewEnabled } = state['features/video-layout'];

        if (!conference) {
            return;
        }
        const {
            active,
            controlledUserId,
            isUserAdmin,
            virtualScreenID,
            statusControl
        } = state['wildix/features/control-sharing'];

        if (!active || statusControl === STATUSES.STOPPED) {
            return;
        }
        const isSharingPlaying = isScreenSharingPlayingByUserID(state, controlledUserId);

        logger.warn(participantId, 'participantId large-video');
        if (isUserAdmin && !tileViewEnabled && isSharingPlaying) {
            if (virtualScreenID === participantId) {
                dispatch(togglePauseResumeControl(false));
            } else if (previousUserID === virtualScreenID) {
                dispatch(togglePauseResumeControl(true));
            }
        }
    }
);

StateListenerRegistry.register(
    /* selector */ state => state['features/base/responsive-ui'],
    /* listener */ ({ clientHeight }, { getState, dispatch }) => {
        const state = getState();
        const { conference } = state['features/base/conference'];

        if (!conference) {
            return;
        }
        const { active, isUserAdmin } = state['wildix/features/control-sharing'];

        if (active && isUserAdmin) {
            changeHeightSharingForLaunchingUser(true,
                {
                    state,
                    dispatch,
                    clientHeight
                });
        }
    }
);


StateListenerRegistry.register(
    /* selector */ state => state['wildix/features/wiservice'].isConnected,
    /* listener */ (isConnected, { dispatch, getState }) => {
        const state = getState();
        const { conference } = state['features/base/conference'];

        if (!conference) {
            return;
        }
        const { active, isUserAdmin } = state['wildix/features/control-sharing'];

        if (!active || isUserAdmin) {
            return;
        }

        if (isConnected) {
            dispatch(wildixServiceRestored());
        } else {
            dispatch(wildixServiceDisconnected());
        }

        logger.warn(isConnected, 'isConnected');
    }
);

StateListenerRegistry.register(
    /* selector */ state => state['wildix/features/control-sharing'].active,
    /* listener */ (activeState, { dispatch, getState }) => {
        dispatch(toggleSelectorControlSharing());
        activeState && isDialogOpened(getState()) && dispatch(hideDialog());
    }
);
StateListenerRegistry.register(
    /* selector */ state => state['features/base/participants'].localScreenShare,
    /* listener */ (track, { dispatch, getState }, deletedTrack) => {
        const state = getState();
        const {
            controlledUserId,
            launchedControlID,
            isAutoStart,
            active,
            statusControl
        } = state['wildix/features/control-sharing'];

        if (isAutoStart && track) {
            const participant = getParticipantByIdOrUndefined(state, launchedControlID);

            if (isSharingTab(state)) {
                dispatch(showWarningNotification({
                    titleKey: 'controlSharing.titleDialogControl',
                    descriptionKey: 'controlSharing.screenSharingTabLocal'
                }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                dispatch(showNotificationSharingTab(controlledUserId, launchedControlID));
                dispatch(setDefaultStoreControlSharing());
            } else if (participant) {
                dispatch(userApproved(launchedControlID, controlledUserId));
            } else {
                dispatch(showWarningNotification({
                    titleKey: 'controlSharing.titleDialogControl',
                    descriptionKey: 'controlSharing.userLeftRoomOrSharing'
                }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                dispatch(setDefaultStoreControlSharing());
                dispatch(callQueryDialogByStep());
            }
        } else if (!track && deletedTrack) {
            if (active) {
                dispatch(sendEventToCloseConnection());
            } else if (statusControl === STATUSES.REQUESTING) {
                dispatch(sendToAllUserStatusSharing(STATUSES.CLOSED));
            }
        }
    }
);
StateListenerRegistry.register(
    /* selector */ state => state['wildix/features/tracks'].error,
    /* listener */ (error, { dispatch, getState }) => {
        if (!error) {
            return;
        }

        const state = getState();
        const { active, launchedControlID, isAutoStart } = state['wildix/features/control-sharing'];

        if (isAutoStart && !active) {
            dispatch(userRejected(launchedControlID));
            dispatch(callQueryDialogByStep());
        }
    }
);

StateListenerRegistry.register(
    /* selector */ state => state['wildix/features/control-sharing'].serviceResponse,
    /* listener */ ({ type, status, reason, description }, { dispatch, getState }) => {
        if (status === WIS_CONTROL_EVENTS.STARTED) {
            logger.warn('Service response: STARTED');
        } else if (type === 'error') {
            logger.warn(status, reason, 'WIService error: status, reason');
            dispatch(sendEventToCloseConnection());
            dispatch(showErrorNotification({
                descriptionKey: 'controlSharing.wildixServiceResponseError',
                descriptionArguments: { reason: description || reason },
                titleKey: 'controlSharing.titleDialogControl'
            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        }
    }
);

StateListenerRegistry.register(
    /* selector */ state => state['features/video-layout'].tileViewEnabled,
    /* listener */ (tileView, { dispatch, getState }) => {
        const state = getState();
        const { conference } = state['features/base/conference'];
        const { active, isUserAdmin, virtualScreenID, statusControl } = state['wildix/features/control-sharing'];

        if (!conference || !active || statusControl === STATUSES.STOPPED) {
            return;
        }
        const { id: participantId } = getPinnedParticipant(state) ?? {};

        if (isUserAdmin) {
            if (typeof tileView === 'undefined' && participantId !== virtualScreenID) {
                return;
            }
            dispatch(togglePauseResumeControl(tileView));
        } else {
            dispatch(toggleSelectorControlSharing());
        }
    }
);

StateListenerRegistry.register(
    /* selector */ state => state['features/base/dialog'].componentProps,
    /* listener */ (props, { dispatch, getState }, prevProps = {}) => {
        const { CONTROL_DIALOG_REQUEST } = prevProps;

        if (CONTROL_DIALOG_REQUEST !== REQUEST_TYPES.CONTROL_DIALOG_REQUEST) {
            return;
        }
        const state = getState();
        const { isAutoStart } = state['wildix/features/control-sharing'];

        if (isAutoStart) {
            return;
        }

        dispatch(callQueryDialogByStep());
    }
);
